'use client'

import React, { useContext } from 'react'
import BannerImage from './BannerImage.component'
import * as S from './Banner.styles'
import { SectionThemeContext } from '../../../contexts/SectionTheme.context'

type BannerType = 'BannerImage'

type ImageShape = 'circle' | 'leaf' | 'ellipse'

interface BannerProps {
  sectionId?: string
  type: BannerType
  as?: React.ElementType
  tabItem?: boolean
  colorScheme?: string
  title?: {
    text: string
    tag?: string
    typo?: string
  }
  subtitle?: {
    text: string
    tag?: string
    typo?: string
  }
  ctaPrimary?: {
    label: string
    href?: string
    variant?: string
  }
  ctaSecondary?: {
    label: string
    href?: string
    variant?: string
  }
  image?: {
    src: string
    alt?: string
    width?: number
    height?: number
  }
  imageShape?: ImageShape,
}

const Banner = ({ sectionId, type, as = 'section', tabItem = false, ...props }: BannerProps) => {
  const { selectedColorScheme } = useContext(SectionThemeContext)

  return (
    <S.Banner as={as} id={sectionId} tabItem={tabItem}>
      <BannerImage {...props} tabItem={tabItem} colorScheme={selectedColorScheme} />
    </S.Banner>
  )
}

export default Banner
